function Indian() {
    return(
        <div>
        <h1>Indian Category</h1>
        <img
      src={require("../../assets/images/prata.jpg")}
      alt="prata"
    /> <br/>
    <img
      src={require("../../assets/images/briyani.jpg")}
      alt="briyani"
    />
        </div>
    )

}
export default Indian;